import { Observable } from 'rxjs';

export interface PageStateService {
    selectors: Record<string, string>;

    select(state: string): Observable<any>;
    dispatch(state: string, stateData: any): void;
    save(state: string, stateData: any): void;
    clear(state?: string): void;
    isSaveRequired(url: string): boolean;
}

export class PageStateService {}
